window.addEventListener('load', function() {
    body.style = '';

	var stickyHeader = new Waypoint({
		element: hero.querySelector('.hero-title'),
		handler: function(direction) {
			var down = direction == 'down';

			if(down)
				body.classList.add('sticky');
			else
				body.classList.remove('sticky');
		},
		offset: header.offsetHeight
	});
});

var lastScrollTop = 0;

window.addEventListener('scroll', function() {
	if(checkWidth(480) && body.classList.contains('sticky') && topbar) {
		var st = window.pageYOffset || document.documentElement.scrollTop;

		if(st > lastScrollTop)
			topbar.classList.add('hide');
		else
			topbar.classList.remove('hide');

		lastScrollTop = st <= 0 ? 0 : st;
	}
});
